import React from 'react';

const CTASection = () => {
  return (
    <section data-screen-label="Final CTA" style={{ padding: 'clamp(40px, 4.5vw, 64px) clamp(16px, 4vw, 48px) clamp(44px, 5vw, 68px)', background: '#26332C', textAlign: 'center' }}>
      <div
        style={{
          maxWidth: '680px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          alignItems: 'center',
        }}
      >
        <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(22px, 4vw, 32px)', color: '#FBFAF6', margin: 0, fontWeight: 800 }}>
          Ready to Get Your Books in Order?
        </h2>
        <p style={{ margin: 0, fontSize: '15px', color: '#D8D2C2' }}>
          One free review tells you exactly where you stand. No obligation, no pressure.
        </p>
        <div
          style={{
            width: '100%',
            maxWidth: '560px',
            background: 'rgba(252, 253, 254, 0.06)',
            border: '1px solid rgba(252, 253, 254, 0.15)',
            borderRadius: '16px',
            padding: '28px',
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
            alignItems: 'center',
          }}
        >
          <a
            href="https://wa.me/971542119784"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              background: '#2BAA5E',
              color: '#FBFAF6',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '15px',
              fontWeight: 800,
              fontFamily: "'Montserrat', sans-serif",
              textDecoration: 'none',
              transition: 'background 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#23934F';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#2BAA5E';
            }}
          >
            <img
              src="/whatsapp-1.png"
              alt="WhatsApp"
              style={{
                width: '18px',
                height: '18px',
                objectFit: 'contain',
                filter: 'brightness(0) invert(1)',
              }}
            />
            WhatsApp Us
          </a>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '12.5px', color: '#8A8377' }}>
            <svg viewBox="0 0 48 48" style={{ width: '14px', height: '14px', display: 'inline-block' }} xmlns="http://www.w3.org/2000/svg" aria-label="Google">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
            </svg>
            <span>
              <strong style={{ color: '#FBFAF6' }}>4.9</strong> on Google — join 500+ businesses who trust us
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
